import { render, staticRenderFns } from "./fakeCallDuration.vue?vue&type=template&id=51c6d580&scoped=true"
import script from "./fakeCallDuration.vue?vue&type=script&lang=js"
export * from "./fakeCallDuration.vue?vue&type=script&lang=js"
import style0 from "./fakeCallDuration.vue?vue&type=style&index=0&id=51c6d580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6d580",
  null
  
)

export default component.exports